import { render, staticRenderFns } from "./ClientSettings.vue?vue&type=template&id=01b748f6&scoped=true&"
import script from "./ClientSettings.vue?vue&type=script&lang=js&"
export * from "./ClientSettings.vue?vue&type=script&lang=js&"
import style0 from "./ClientSettings.vue?vue&type=style&index=0&id=01b748f6&scoped=true&lang=css&"
import style1 from "./ClientSettings.vue?vue&type=style&index=1&id=01b748f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b748f6",
  null
  
)

export default component.exports